import { SvgIcon } from '@cinch-labs/design-system'
import { StoryBenefitsEvCard } from '../../types/electric-cars-page'
import styles from './ev-info-card.module.css'
interface EvInfoCardProps {
  evInfo: StoryBenefitsEvCard[]
}

export const EvInfoCard = ({ evInfo }: EvInfoCardProps) => {
  const { title, text } = evInfo[0]
  return (
    <div className={styles.cardContainer}>
      <div className={styles.iconTitleContainer}>
        <SvgIcon name="lightbulb" size={24} />
        <h3>{title}</h3>
      </div>
      <p className={styles.text}>{text}</p>
    </div>
  )
}
